import api from './client'

export interface AiJob {
  id: string
  status: string
  progress: string
  provider: string
  input_type: string
  results: {
    question_name: string
    value: string | string[]
    confidence: number
    source: string
  }[]
  error_message: string
  created_at: string
  completed_at: string | null
}

export interface AiConfig {
  default_provider: string
  gemini_model: string
  deepseek_model: string
  privacy_notice: string
}

export interface AiFetchPmcPayload {
  pmc_id: string
}

export interface AiFetchPmcOut {
  success: boolean
  pmc_id: string
  title: string
  text: string
  available: boolean
  error: string
}

export interface AiExtractPayload {
  submission_id: string
  provider?: 'gemini' | 'deepseek'
  input_type: 'pmc_id' | 'text'
  input_ref: string
}

export interface AiApplyPayload {
  submission_id: string
  job_id: string
  accepted: string[]
}

export interface AiFeedbackPayload {
  submission_id: string
  question_name: string
  question_label?: string
  original_value: string
  corrected_value: string
  feedback_type?: 'wrong' | 'incomplete' | 'missing' | ''
  comment?: string
  was_ai_filled?: boolean
  manuscript_snippet?: string
}

export const aiApi = {
  getConfig: () => api.get<AiConfig>('/ai/config').then((r) => r.data),
  fetchPmc: (payload: AiFetchPmcPayload) =>
    api.post<AiFetchPmcOut>('/ai/fetch-pmc', payload).then((r) => r.data),
  extract: (payload: AiExtractPayload) =>
    api.post<{ job_id: string; status: string }>('/ai/extract', payload).then((r) => r.data),
  getJob: (jobId: string) => api.get<AiJob>(`/ai/jobs/${jobId}`).then((r) => r.data),
  apply: (payload: AiApplyPayload) => api.post('/ai/apply', payload).then((r) => r.data),
  feedback: (payload: AiFeedbackPayload) => api.post('/ai/feedback', payload).then((r) => r.data),
}
